import { capTableSharesFormat, sharesFormat } from 'common/formats/formats';
import type { RowFormat } from 'common/types/scalarSpreadsheet';
import type { CellAnnotationConfig } from 'components/CellAnnotationValueViewer/types';
import type { InheritedCellFormat } from 'components/CellAnnotationValueViewer/utils/extractFormatFromCell';

export const NET_SHARES_CROSS_REFERENCE_CONFIG: CellAnnotationConfig = {
  annotationType: 'cross_reference',
  rowMode: 'multi_row',
  columns: [
    { alias: 'shares', header: 'Shares' },
    { alias: 'entity', header: 'Entity' },
  ],
};

export const NET_SHARES_INHERITED_FORMAT: InheritedCellFormat = {
  gridType: 'number',
  format: sharesFormat as RowFormat,
  currency: undefined,
};

export const FULLY_DILUTED_TOTAL_CROSS_REFERENCE_CONFIG: CellAnnotationConfig = {
  annotationType: 'cross_reference',
  rowMode: 'single_cell',
  columns: [{ alias: 'value' }],
};

export const FULLY_DILUTED_TOTAL_INHERITED_FORMAT: InheritedCellFormat = {
  gridType: 'number',
  format: capTableSharesFormat as RowFormat,
  currency: undefined,
};
